var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ft_phone flex2"},[_c('div',{staticClass:"ft_p1"},[_vm._v("COPYRIGHT © 2025 徐州市交通控股集团有限公司 ALL RIGHTS RESERVED."),_c('span',{on:{"click":_vm.toGongXin}},[_vm._v(_vm._s(_vm.basic.beian))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }